import { render } from "./sales-order-status-badge.vue?vue&type=template&id=5460cca7"
import script from "./sales-order-status-badge.vue?vue&type=script&lang=js"
export * from "./sales-order-status-badge.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__